import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import globalClasses from 'global.module.css';
import { PatientGroups } from 'utils/models';
import { useAppContext } from 'context/hooks';
import classes from './GroupLabel.module.css';

interface Props {
  group: PatientGroups;
  onClick?: () => void;
  showDaysLeftLabel?: boolean;
}

export const GroupLabel = ({ group, onClick, showDaysLeftLabel = false }: Props) => {
  const { t } = useTranslation();
  const { currentUser } = useAppContext();
  const { expired, daysLeft } = group;
  const name = currentUser?.visibleGroups.find((visibileGroup) => visibileGroup.id === group.id)?.name ?? '??';

  const renderDaysLeft = (value: number) => {
    if (value <= 0) return 0;
    if (value < 1) return 1;
    if (value >= 1) return value.toFixed(0);
    return '-';
  };

  const renderDaysLeftLabel = (value: number) => {
    if (value <= 0) return t('days_left_label');
    if (value <= 1) return t('day_left_label');
    if (value > 1) return t('days_left_label');
    return '';
  };

  return (
    <Flex align={'stretch'} h={'auto'}>
      <Flex
        onClick={onClick}
        className={`${classes.groupLabel} ${classes.groupLabelName} ${onClick ? globalClasses.cursorPointer : ''}`}
        bg={expired ? 'var(--mantine-color-gray-1)' : 'var(--mantine-color-blue-3)'}
        c={expired ? 'var(--mantine-color-text)' : 'var(--mantine-color-white)'}
      >
        {name}
      </Flex>
      <Flex
        className={`${classes.groupLabel} ${classes.groupLabelDays}`}
        bg={expired ? 'var(--mantine-color-gray-3)' : 'var(--mantine-color-blue-5)'}
        align={'center'}
      >
        {renderDaysLeft(daysLeft)}
        {showDaysLeftLabel && ` ${renderDaysLeftLabel(daysLeft)}`}
      </Flex>
    </Flex>
  );
};
